module.exports = __webpack_public_path__ + "static/img/visa.89ed4ae.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Home/visa.png
// module id = IXSk
// module chunks = 1